define("shared/components/shared/ui/button", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/debug", "@ember/object", "@ember/utils", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _debug, _object, _utils, _component2, _tracking, _emberConcurrency, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/debug",0,"@ember/object",0,"@ember/utils",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{!  template-lint-disable require-button-type }}
  {{!  template-lint-disable @latermedia/later-template-linting/use-other-component }}
  <button
    aria-disabled={{or this.isRunning @isDisabled}}
    {{button variant=@variant size=@size additional=@additional class=(concat @class this.disabledClass)}}
    {{on "click" this.handleClick}}
    ...attributes
  >
    {{#if (has-block)}}
      {{yield}}
    {{else}}
      {{#if (and this.isRunning @runningText)}}
        {{@runningText}}
      {{else}}
        {{this.verifiedText}}
      {{/if}}
    {{/if}}
  </button>
  */
  {
    "id": "WMdYY4/R",
    "block": "[[[11,\"button\"],[16,\"aria-disabled\",[28,[37,0],[[30,0,[\"isRunning\"]],[30,1]],null]],[17,2],[4,[38,1],null,[[\"variant\",\"size\",\"additional\",\"class\"],[[30,3],[30,4],[30,5],[28,[37,2],[[30,6],[30,0,[\"disabledClass\"]]],null]]]],[4,[38,3],[\"click\",[30,0,[\"handleClick\"]]],null],[12],[1,\"\\n\"],[41,[48,[30,8]],[[[1,\"    \"],[18,8,null],[1,\"\\n\"]],[]],[[[41,[28,[37,7],[[30,0,[\"isRunning\"]],[30,7]],null],[[[1,\"      \"],[1,[30,7]],[1,\"\\n\"]],[]],[[[1,\"      \"],[1,[30,0,[\"verifiedText\"]]],[1,\"\\n\"]],[]]]],[]]],[13]],[\"@isDisabled\",\"&attrs\",\"@variant\",\"@size\",\"@additional\",\"@class\",\"@runningText\",\"&default\"],false,[\"or\",\"button\",\"concat\",\"on\",\"if\",\"has-block\",\"yield\",\"and\"]]",
    "moduleName": "shared/components/shared/ui/button.hbs",
    "isStrictMode": false
  });
  /**
   * This component provides a Wrapper around an HTML button, to quickly create
   * properly styled buttons that can take an action to trigger when the button is clicked.
   *
   * This makes use of the `{{button}}` modifier to apply the correct classes to the target button.
   * The "size", "variant", and "additional" arguments are forwarded directly to the `{{button}}` modifier.
   *
   * All HTML Attributes (class, aria-*, data-*, etc.) are automatically applied to the rendered <button ...> tag
   * and are valid attributes on this component.
   *
   * Arguments:
   * - [size] Button Size (default: "regular")
   * - [variant] Button color styling (default: "primary")
   * - [additional] Button options (default: null)
   * - [text] The text displayed on the button.Required for inline usage. If this component is invoked as a block,
   *   the block contents will be used instead of this property. (default: "")
   * - [runningText] The text displayed when button is running.
   * - [isDisabled] Whether or not the button is disabled (default: false)
   * - [onClick] Click handler for button
   * - [promise] Task for button which when handled will disable the button while task is running
   *
   * Examples:
   *
   * Simple Usage:
   * ```
   * <Shared::Ui::Button @text="Click Me" />
   * <Shared::Ui::Button @text="Click Me" @size="large" @variant="outline" />
   * ```
   *
   * Inline Usage with all options:
   * ```
   * <Shared::Ui::Button
   *  @text="Click Me"
   *  @size="large"
   *  @variant="outline"
   *  @additional="block"
   *  @isDisabled={{true}}
   *  @onClick={{action "handleClick"}}
   * />
   * ```
   *
   * Block Usage:
   * ```
   * <Shared::Ui::Button
   *  @size="regular"
   *  @variant="primary"
   *  @onClick={{action "handleClick"}}
   * >
   *  {{#if inputType.isMouse}}
   *    Click Here
   *  {{else}}
   *    Tap Here
   *  {{/if}}
   * </Shared::Button::Upgrade>
   * ```
   */
  let ButtonComponent = _exports.default = (_class = class ButtonComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "isRunning", _descriptor, this);
      _defineProperty(this, "promiseHandler", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          if (this.isDisabled || !this.args.promise) {
            return;
          }
          try {
            this.isRunning = true;
            yield this.args.promise.unlinked().perform();
          } finally {
            this.isRunning = false;
          }
        }
      }), {
        drop: true
      }, "promiseHandler", null));
    }
    get isDisabled() {
      return this.args.isDisabled || false;
    }
    get verifiedText() {
      (false && !((0, _utils.isPresent)(this.args.text)) && (0, _debug.assert)('The `@text` argument is required with inline usage', (0, _utils.isPresent)(this.args.text)));
      return this.args.text;
    }
    get disabledClass() {
      if (this.isDisabled || this.isRunning) {
        return ' o--btn--disabled';
      }
      return '';
    }
    handleClick(event) {
      if (this.args.promise || this.args.onClick) {
        event.preventDefault();
      }
      if (this.isDisabled || this.isRunning) {
        return;
      }
      if (this.args.promise) {
        this.promiseHandler.perform();
        return;
      }
      if (this.args.onClick) {
        this.args.onClick(event);
        return;
      }
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "isRunning", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "handleClick", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleClick"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ButtonComponent);
});